import React from "react";

// OP-5 - badges e helpers reutilizaveis do modulo de Oportunidades.

export const INTENT_META = {
  HIGH: { label: "Alta", cls: "bg-red-100 text-red-700", icon: "🔥" },
  MEDIUM: { label: "Média", cls: "bg-amber-100 text-amber-700", icon: "🟡" },
  LOW: { label: "Baixa", cls: "bg-sky-100 text-sky-700", icon: "🔵" },
  NONE: { label: "—", cls: "bg-gray-100 text-gray-500", icon: "" },
};

export const STATUS_META = {
  NEW: { label: "Nova", cls: "bg-brand/10 text-brand" },
  VIEWED: { label: "Visualizada", cls: "bg-indigo-100 text-indigo-700" },
  CONTACTING: { label: "Em atendimento", cls: "bg-amber-100 text-amber-700" },
  CONVERTED: { label: "Convertida", cls: "bg-emerald-100 text-emerald-700" },
  LOST: { label: "Não convertida", cls: "bg-red-100 text-red-700" },
  CANCELLED: { label: "Cancelada", cls: "bg-gray-100 text-gray-600" },
};

export const SOURCE_LABEL = {
  WHATSAPP_STATUS: "Status WhatsApp",
  WHATSAPP_DIRECT: "WhatsApp oficial",
  WHATSAPP_CATALOG: "Catálogo WhatsApp",
  CAMPAIGN: "Campanha",
  MANUAL: "Manual",
  OTHER: "Outros",
};

export const BU_LABEL = {
  CRIS: "Cris Lingerie",
  ELETROS: "Eletros",
  UNKNOWN: "Segmento não identificado",
};

export function IntentBadge({ level, className = "" }) {
  const m = INTENT_META[level] || INTENT_META.NONE;
  return (
    <span
      data-testid={`opp-intent-${level}`}
      aria-label={`Intenção ${m.label}`}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${m.cls} ${className}`}
    >
      <span aria-hidden="true">{m.icon}</span>
      {m.label}
    </span>
  );
}

export function StatusBadge({ status, className = "" }) {
  const m = STATUS_META[status] || STATUS_META.NEW;
  return (
    <span
      data-testid={`opp-status-${status}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${m.cls} ${className}`}
    >
      {m.label}
    </span>
  );
}

export function relativeTime(iso) {
  if (!iso) return "";
  try {
    const then = new Date(iso).getTime();
    const diff = Math.max(0, Date.now() - then);
    const min = Math.floor(diff / 60000);
    if (min < 1) return "agora mesmo";
    if (min < 60) return `há ${min} min`;
    const h = Math.floor(min / 60);
    if (h < 24) return `há ${h} h`;
    const d = Math.floor(h / 24);
    if (d === 1) return "ontem";
    if (d < 30) return `há ${d} dias`;
    return new Date(iso).toLocaleDateString("pt-BR");
  } catch {
    return "";
  }
}

export function fullDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", {
      day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function timeHM(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}
